import { Sparkles } from 'lucide-react'

import { CAPABILITIES_SETTINGS_HREF } from './nav-badges'
import { NoticeBanner } from './notice-banner'

/** app-wide notice for suppliers that predate the capability taxonomy. clears
 *  itself the moment they save capabilities in the new picker. */
export function CapabilitiesUpdateBanner({
  userId
}: {
  userId: string | null
}) {
  return (
    <NoticeBanner
      tone='warning'
      icon={Sparkles}
      action={{ label: 'Update now', to: CAPABILITIES_SETTINGS_HREF }}
      dismissId={`capabilities:${userId ?? 'anon'}`}
    >
      We&rsquo;ve upgraded how capabilities work. Re-select yours in the new,
      more detailed format so buyers can find you accurately.
    </NoticeBanner>
  )
}
